_ = require 'underscore'
PluginRunner = require 'views/internal/plugins/plugin-runner'
pluginsChangedSignal = require 'views/internal/plugins/plugins-changed-signal'
PluginView = require 'views/plugin/plugin-view'

module.exports = class PluginButtonsView extends PluginView
  buttonsSelector: '.js-button-list'
  buttonView: null

  renderContainer: ->
    @$el

  runnerOptions: ->
    throw Error('runnerOptions not specified')

  vigor: @VIGOR.NONE
  renderOnce: ->
    options = @runnerOptions()

    $target = @renderContainer()

    @subscribe pluginsChangedSignal(options.board, options.card), =>
      PluginRunner.all options
      .then (pluginButtons) =>
        @$el.toggleClass('hide', pluginButtons.length == 0)

        @removeSubviews()

        subviews = _.sortBy(pluginButtons, 'text').map (pluginButton, index) =>
          @subview @buttonView, @model, { pluginButton }, index
        @appendSubviews subviews, $target
      .done()

    @



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-buttons-view.coffee